const statusIcons = {
  'null': {
    value: 'null',
    label: 'Em análise',
    icon: 'drafts',
    color: '',
  },

  'em_diligencia': {
    value: 'em_diligencia',
    label: 'Em Diligência',
    icon: 'announcement',
    color: 'yellow',
  },

  'p_aprovada': {
    value: 'p_aprovada',
    label: 'Aprovada',
    icon: 'done',
    color: 'success',
  },

  'proposta_aprovada': {
    value: 'proposta_aprovada',
    label: 'Aprovada e Divulgada',
    icon: 'done_all',
    color: 'success',
  },

  'p_reprovada': {
    value: 'p_reprovada',
    label: 'Reprovada',
    icon: 'done',
    color: 'red',
  },

  'reprovada': {
    value: 'reprovada',
    label: 'Reprovada e Divulgada',
    icon: 'done_all',
    color: 'red',
  }
};


export default statusIcons;


// WEBPACK FOOTER //
// ./src/const/project/opportunityStatusIcons.js